import React from 'react';
import "./BlogPost.css";
import picture1 from '../../Assets/b58/picture1.jpg';
import picture2 from '../../Assets/b58/picture2.jpg';

function Blog58(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>When we simplify, we amplify. 💬✂️</h1>
            <h6>October 18, 2024 at 02:41 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel carousel-dark slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={picture1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={picture2} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>Just wrapped up the LEAP Camp: Basic Communication Workshop, where we learned that less is often more when it comes to effective communication.
                 It’s amazing how simplifying our messages can get our message across clearly and concisely,
                  making it easier to connect with others and get things done. 💡🔑</p>
            <p><a href='https://www.facebook.com/hashtag/leapcamp' target='_blank' className='blog-link'>
              #LEAPCAMP</a>
              <a href='https://www.facebook.com/hashtag/effectivecommunication' target='_blank' className='blog-link'>
              #EffectiveCommunication </a>
              <a href='https://www.facebook.com/hashtag/teamwork' target='_blank' className='blog-link'>
              #Teamwork</a>
              <a href='https://www.facebook.com/hashtag/mytculture' target='_blank' className='blog-link'>
              #MYTCulture</a>
              <a href='https://www.facebook.com/hashtag/continuousimprovement' target='_blank' className='blog-link'>
              #ContinuousImprovement</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog58;